import { WildlifePropertyMappingsConst } from '@kildenshared/constants/wildlife-property-mappings.const';
import { FeatureLike } from 'ol/Feature';
import { Stroke } from 'ol/style';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import RegularShape from 'ol/style/RegularShape';
import Style, { StyleFunction } from 'ol/style/Style';
import Text from 'ol/style/Text';

export const WildPointsStyle: StyleFunction = (feature: FeatureLike, resolution: number): Style | Style[] => {
  const properties: {
    [key in keyof typeof WildlifePropertyMappingsConst]: string | any;
  } = Object.assign({}, WildlifePropertyMappingsConst, feature.getProperties());

  const sex: string = feature.get('sex').toString();
  const isFirstPoint = feature.get('is_first_point') === true;
  const isLastPoint = feature.get('is_last_point') === true;
  const isHighlightedPoint = isFirstPoint || isLastPoint;
  const alwaysShowHighlightTimestamp = feature.get('always_show_highlight_timestamp') === true; // if one animal selected time stamp for first and last point should always be visible, not only when zoomed in
  // for first and last point we want to use a bigger symbol and show the timestamp when zoomed out, for other points we want to show the timestamp only when zoomed in
  const symbolRadius = isHighlightedPoint ? 9 : 7;

  const olStroke = new Stroke({
    color: properties['symbol_line'] || [0, 0, 0, 1],
    width: isHighlightedPoint ? 2.5 : 1,
  });

  const olFill = new Fill({
    color: properties['symbol_color'] || 'blue',
  });

  const triangle = new RegularShape({
    fill: olFill,
    stroke: olStroke,
    points: 3,
    radius: symbolRadius,
    //rotation: Math.PI / 4,
    angle: 0,
  });

  const circle = new Circle({
    radius: symbolRadius,
    fill: olFill,
    stroke: olStroke,
  });

  const square = new RegularShape({
    fill: olFill,
    stroke: olStroke,
    points: 4,
    radius: symbolRadius,
    rotation: Math.PI / 4,
    angle: 0,
  });

  let symbolShape = triangle;
  if (properties['symbol'] === 'circle') {
    symbolShape = circle;
  } else if (properties['symbol'] === 'square') {
    symbolShape = square;
  }

  let textScale = 0.01;
  if (resolution < 2) {
    textScale = 1;
  }
  // if point is first or last point show the timestamp when zoomed out until målestokk 1:50000, for other points show the timestamp only when zoomed in, but if only one animal is selected we show the timestamp for first and last point always
  const visibleTextScale = isHighlightedPoint
    ? alwaysShowHighlightTimestamp || resolution <= 14
      ? 1
      : 0.01
    : textScale;

  if (properties['collar_id'] !== '0') {
    return [
      new Style({
        image: symbolShape,
        text: new Text({
          font: isHighlightedPoint ? '700 11px helvetica,sans-serif' : '10px helvetica,sans-serif',
          scale: visibleTextScale,
          text: properties['Acquisition_time'],
          offsetY: -20,
          //rotation: 360 * rnd * Math.PI / 180,
          fill: new Fill({
            color: '#000',
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 4,
          }),
        }),
      }),
    ];
  } else {
    return [];
  }
};
